import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Shield, Search, Landmark, FileCheck, Building, UserCheck } from "lucide-react";

const iconMap = {
  Shield,
  Search,
  Landmark,
  FileCheck,
  Building,
  UserCheck,
};

export const ServiceCard = ({ service, index = 0 }) => {
  const Icon = iconMap[service.icon] || Shield;

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <Link
        to={`/services/${service.slug}`}
        data-testid={`service-card-${service.slug}`}
        className="block group relative"
      >
        <motion.div
          whileHover={{
            rotateX: -3,
            rotateY: 3,
            scale: 1.02,
            transition: { duration: 0.3 },
          }}
          style={{ transformPerspective: 1000 }}
          className="relative bg-[#0F1116]/60 backdrop-blur-xl border border-white/[0.06] rounded-xl overflow-hidden transition-all duration-500 hover:border-blue-500/20 hover:shadow-[0_0_40px_rgba(59,130,246,0.1)]"
        >
          {/* Image */}
          <div className="relative h-48 overflow-hidden flex items-center justify-center">
            <img
              src={service.image}
              alt={service.title}
              className="w-full object-contain transition-transform duration-700 group-hover:scale-110"
              loading="lazy"
            />
            {/* <div className="absolute inset-0 bg-gradient-to-t from-[#0F1116] via-[#0F1116]/20 to-transparent" /> */}

            {/* Shine effect on hover */}
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
            </div>
          </div>

          {/* Content */}
          <div className="p-6">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-lg bg-blue-500/10 border border-blue-500/20 flex items-center justify-center">
                <Icon className="w-5 h-5 text-blue-400" />
              </div>
              <h3 className="font-outfit font-semibold text-slate-100 text-lg">
                {service.title}
              </h3>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed line-clamp-2">
              {service.shortDesc}
            </p>

            {/* Arrow */}
            <div className="mt-4 flex items-center gap-2 text-blue-400 text-sm font-medium opacity-0 group-hover:opacity-100 transform translate-x-0 group-hover:translate-x-2 transition-all duration-300">
              Learn More
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </div>
          </div>

          {/* Bottom glow line */}
          <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-blue-500/0 to-transparent group-hover:via-blue-500/50 transition-all duration-700" />
        </motion.div>
      </Link>
    </motion.div>
  );
};
